/* eslint-disable import/no-unresolved */
import PropTypes from 'prop-types';
import { SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';

import RichText from '../../../Core/RichText';
import DesktopProductStep from '../../Cards/DesktopProductStep';
import Ctas from '../../../Core/Ctas';
import Carousel from '../../../Core/Carousel';

import {
  StyledContainer,
  Heading,
  Footer,
  StepContainers,
  StepNumber,
} from './styles';

const breakpoints = {
  320: {
    slidesPerView: '1',
    spaceBetween: 24,
  },
  768: {
    slidesPerView: '1',
    spaceBetween: 24,
  },
};

const DesktopCarouselBanner = ({ data }) => {
  if (!data) return null;
  const {
    component,
    heading,
    headingAlignment,
    cards,
    ctas,
    CtaMessage,
    elements,
    backgroundColor,
    sectionContainerHeading,
  } = data;

  const handleSlideChange = s => {
    if (s) {
      const stepContainer = document.querySelector('.step-container');
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < stepContainer.children.length; i++) {
        stepContainer.children[i].classList.remove('active');
      }
      stepContainer.children[s.activeIndex].classList.add('active');
    }
  };

  const carouselItems = cards || elements;

  return (
    <StyledContainer
      className={`${component} auto-margin`}
      backgroundColor="transparent"
    >
      {heading && (
        <Heading className={headingAlignment}>
          <RichText document={heading} />
        </Heading>
      )}
      {sectionContainerHeading && (
        <Heading
          className={`${headingAlignment} columns-${carouselItems.length}`}
        >
          <RichText document={sectionContainerHeading} />
        </Heading>
      )}
      <StepContainers className={`${backgroundColor} step-container`}>
        {carouselItems.map((prod, x) => (
          <StepNumber key={`${prod.id}`}>
            <p>{x + 1}</p>
          </StepNumber>
        ))}
      </StepContainers>
      <Carousel
        breakpoints={breakpoints}
        onSlideChange={handleSlideChange}
        onInit={handleSlideChange}
        modules={[Pagination]}
        pagination={{ clickable: true }}
      >
        {carouselItems.map(product => {
          return (
            <SwiperSlide key={product.id}>
              <DesktopProductStep data={product} component={component} />
            </SwiperSlide>
          );
        })}
      </Carousel>
      {(CtaMessage || ctas) && (
        <Footer>
          {CtaMessage && <h3>{CtaMessage}</h3>}
          {ctas && <Ctas ctas={ctas} position="center" />}
        </Footer>
      )}
    </StyledContainer>
  );
};

DesktopCarouselBanner.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default DesktopCarouselBanner;
